"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorage = void 0;
var object_utils_1 = require("../utils/object.utils");
var memoryCache = new Map();
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage(config) {
        this.config = config;
    }
    MemoryStorage.prototype.setItem = function (key, value) {
        if (!(value == null || value.length === 0)) {
            memoryCache.set(key, value);
            return this.getItem(value);
        }
        return null;
    };
    MemoryStorage.prototype.getItem = function (key) {
        return object_utils_1.isEmpty(memoryCache.get(key))
            ? null
            : memoryCache.get(key);
    };
    MemoryStorage.prototype.removeItem = function (key) {
        return memoryCache.delete(key);
    };
    MemoryStorage.prototype.clear = function () {
        memoryCache = new Map();
        return {};
    };
    return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;
//# sourceMappingURL=memory.storage.js.map